module.exports = __webpack_public_path__ + "img/02-6即时填报.46700e53.svg";